/**
 * The confidence display's view layer: the two check cards and the evidence dialog, with the calls
 * behind them.
 *
 * The hooks are exported alongside the views because a page may need the request state without the
 * cards, for example to decide whether to offer a request control elsewhere. `requestStateFromTasks`
 * is exported for the same reason a component's copy resolver is: a call site that re-derives which
 * task statuses count as open can get it wrong, and the answer decides whether a client is told they
 * are repeating a request.
 */
export { default as CustomerConfidenceCards } from './CustomerConfidenceCards';
export type { TCustomerConfidenceCardsProps } from './CustomerConfidenceCards';

export { default as BiometricEvidence } from './BiometricEvidence';
export type { TBiometricEvidenceProps } from './BiometricEvidence';

export { default as IdPortraitEvidence } from './IdPortraitEvidence';
export type { TIdPortraitEvidenceProps } from './IdPortraitEvidence';

export { useCustomerConfidence } from './useCustomerConfidence';
export type {
  TBiometricAxisState,
  TConfidenceAxisState,
  TDocumentAxisState,
  TProblemDocumentType,
  TUseCustomerConfidence,
  TUseCustomerConfidenceParams,
} from './useCustomerConfidence';

export { useFaceCheckTasks } from './useFaceCheckTasks';
export type { TUseFaceCheckTasks, TUseFaceCheckTasksParams } from './useFaceCheckTasks';

export { useBiometricEvidence } from './useBiometricEvidence';
export type { TUseBiometricEvidence, TUseBiometricEvidenceParams } from './useBiometricEvidence';

export { useIdPortraitEvidence } from './useIdPortraitEvidence';
export type { TUseIdPortraitEvidence, TUseIdPortraitEvidenceParams } from './useIdPortraitEvidence';

export { requestStateFromTasks } from './requestState';
export type { TFaceCheckTask, TRequestState } from './requestState';

export {
  CustomerConfidenceProvider,
  useCustomerConfidenceContext,
} from './CustomerConfidenceContext';
export type { TCustomerConfidenceProviderProps } from './CustomerConfidenceContext';
